import { memo } from 'react';

import Url from 'types/Url';
import { VariantAttributeValue } from 'types/models/VariantAttributeValue';
import ProductOptionGroup from 'types/ProductOptionGroup';

import OptionGroup from './components/OptionGroup';
import classes from './Options.module.scss';

type Props = {
  optionGroups: ProductOptionGroup[];
  availableOptionGroups: ProductOptionGroup[];
  predictedOptionGroups: ProductOptionGroup[];
  selectedOptions: { [key in ProductOptionGroup['id']]: ProductOptionGroup['id'] };
  onHoverOption: (
    groupId: string,
    variantId: number,
    variantAttributeValue?: VariantAttributeValue,
    hoverIn?: boolean
  ) => void;
  onSelectOption: (variantId: number, href: Url) => void;
};

const Options = ({
  optionGroups,
  availableOptionGroups,
  predictedOptionGroups,
  selectedOptions,
  onHoverOption,
  onSelectOption,
}: Props): JSX.Element => (
  <div className={classes.wrapper}>
    {optionGroups.map(({ id, title, info, infoModal, collapsedItemsMinCount, maxItemsInRow, options }) => (
      <div key={id} className={classes.option}>
        <OptionGroup
          id={id}
          title={title}
          info={info}
          infoModal={infoModal}
          collapsedItemsMinCount={collapsedItemsMinCount}
          maxItemsInRow={maxItemsInRow}
          options={options}
          availableOptions={availableOptionGroups.find(({ id: groupId }) => groupId === id)?.options || []}
          predictedOptions={predictedOptionGroups.find(({ id: groupId }) => groupId === id)?.options || []}
          selectedId={selectedOptions[id]}
          onHoverOption={onHoverOption}
          onSelectOption={onSelectOption}
        />
      </div>
    ))}
  </div>
);

export default memo(Options);
